<template>
  <div class="panel panel-primary">
    <slot name="header">
      <h2 class="ml-10">Overall Performance</h2>
    </slot>
    <div class="m-15">
      <chart class="mt-20" :score="score"></chart>

      <template v-if="scoringMethod === 'percentage'">
        <h3 class="text-center mt-30">{{ score | badPercent }}</h3>
      </template>
      <template v-else>
        <h3 class="text-center mt-30">{{ score | getOrdinal }} Percentile</h3>
      </template>

      <div class="lead">
        <template v-if="message">
          {{ message }}
        </template>
        <template v-else-if="scoringMethod === 'percentage'">
          Your overall score was {{ score | badPercent }}. This overall score is based on how
          accurately you responded to the emails and messages during the exercise. It is calculated
          by dividing the total points that are achievable by the points that you have earned, and
          it takes all measured skills into account.
        </template>
        <template v-else>
          Your overall performance was {{ score | getOrdinal }} percentile. This overall score is
          based on how accurately you responded to the emails and messages during the exercise. The
          score is a percentile, which shows your overall performance relative to the CapsimInbox
          database. A score of {{ score | getOrdinal }} percentile means that you performed higher
          than {{ score | badPercent }} of the individuals in the database.
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import chart from './chartOverall.vue';

  export default {
    name: 'OverallScore',

    components: { chart },

    props: {
      score: {
        required: true,
      },
      message: {
        default: null,
        type: String,
      },
      scoreFilter: {},
      scoringMethod: {
        default: 'percentile',
        type: String,
      },
    },

    filters: {
      getOrdinal(n) {
        const s = ['th', 'st', 'nd', 'rd'];
        const v = n % 100;
        return `${n + (s[(v - 20) % 10] || s[v] || s[0])}`;
      },

      badPercent(n) {
        return `${n}%`;
      },
    },
  };
</script>
